/* age gate + cinematic intro + reveal tagging
   Runs on every page. Gate is remembered, intro plays on the homepage only. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root   = document.documentElement;

  var gate        = document.getElementById('agegate'),
      deny        = document.getElementById('gate-deny'),
      yes         = document.getElementById('gate-yes'),
      no          = document.getElementById('gate-no'),
      intro       = document.getElementById('intro'),
      stage       = document.getElementById('stage'),
      bottleWrap  = document.getElementById('bottleWrap'),
      hero        = document.getElementById('top');

  var isHome    = root.getAttribute('data-template') === 'index';
  var wantIntro = root.getAttribute('data-intro') === 'true';
  var wantGate  = root.getAttribute('data-gate') === 'true';

  /* ---------- memory ---------- */
  var GATE_KEY = 'pg_age_ok', GATE_DAYS = 30, INTRO_KEY = 'pg_intro_seen';
  function store(api){ try{ return window[api]; }catch(e){ return null; } }
  function gatePassed(){
    var ls = store('localStorage'); if(!ls) return false;
    var v = ls.getItem(GATE_KEY);
    if(!v) return false;
    if(Date.now() - parseInt(v,10) > GATE_DAYS*864e5){ ls.removeItem(GATE_KEY); return false; }
    return true;
  }
  function rememberGate(){ var ls=store('localStorage'); if(ls) ls.setItem(GATE_KEY, String(Date.now())); }
  function introSeen(){ var ss=store('sessionStorage'); return ss ? ss.getItem(INTRO_KEY)==='1' : false; }
  function rememberIntro(){ var ss=store('sessionStorage'); if(ss) ss.setItem(INTRO_KEY,'1'); }

  /* ---------- reveal ---------- */
  document.querySelectorAll('.hero-copy > *').forEach(function(el){ el.classList.add('reveal'); });
  document.querySelectorAll('.sec-head,.taste-card,.serve,.award,.story-copy,.seal-wrap,.cta-final .inner,.merch-copy,.merch-art')
    .forEach(function(el){ el.classList.add('reveal'); });

  function show(el){
    el.classList.add('in');
    setTimeout(function(){ el.classList.remove('reveal','in'); }, 1000);
  }
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ show(e.target); io.unobserve(e.target); } });
    },{threshold:.16, rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){
      if(!el.closest('.hero-copy')) io.observe(el);
    });
  } else {
    document.querySelectorAll('.reveal').forEach(show);
  }

  function revealHero(){
    if(stage) stage.classList.add('in');
    document.querySelectorAll('.hero-copy .reveal').forEach(show);
  }
  function lock(){ document.body.style.overflow='hidden'; }
  function unlock(){ document.body.style.overflow=''; }

  /* ---------- entry ---------- */
  function playIntro(){
    if(!intro || !isHome || !wantIntro || reduce || introSeen()){
      if(intro) intro.classList.add('hide');
      revealHero(); unlock(); rememberIntro();
      return;
    }
    lock();
    intro.classList.remove('hide');
    setTimeout(function(){ intro.classList.add('out'); revealHero(); }, 2700);
    setTimeout(function(){ intro.classList.add('hide'); unlock(); rememberIntro(); }, 3600);
  }

  function openGate(){
    if(!gate) { playIntro(); return; }
    gate.classList.remove('hide');
    lock();
    if(yes) yes.focus();
  }

  if(gate && wantGate && !gatePassed()){
    openGate();
  } else {
    if(gate) gate.classList.add('hide');
    playIntro();
  }

  var mode   = gate ? gate.getAttribute('data-mode') : 'yesno';
  var minAge = gate ? (parseInt(gate.getAttribute('data-min-age'), 10) || 21) : 21;

  function ageFrom(y, m, d){
    var now = new Date();
    var age = now.getFullYear() - y;
    var beforeBirthday = (now.getMonth() + 1) < m ||
                         ((now.getMonth() + 1) === m && now.getDate() < d);
    if (beforeBirthday) age -= 1;
    return age;
  }

  function pass(){
    rememberGate();
    if(gate) gate.classList.add('hide');
    playIntro();
  }

  if(yes) yes.addEventListener('click', function(){
    if(mode !== 'dob'){ pass(); return; }

    var m = parseInt((document.getElementById('gate-m')||{}).value, 10);
    var d = parseInt((document.getElementById('gate-d')||{}).value, 10);
    var y = parseInt((document.getElementById('gate-y')||{}).value, 10);

    if(!m || !d || !y || y < 1900 || y > new Date().getFullYear()){
      if(deny) deny.textContent = 'Please enter a full date of birth.';
      return;
    }
    var probe = new Date(y, m - 1, d);
    if(probe.getFullYear() !== y || probe.getMonth() !== m - 1 || probe.getDate() !== d){
      if(deny) deny.textContent = 'That date does not exist. Please check it.';
      return;
    }
    if(ageFrom(y, m, d) < minAge){
      if(deny) deny.textContent = 'You must be ' + minAge + ' or older to enter this site.';
      return;
    }
    pass();
  });

  if(no) no.addEventListener('click', function(){
    if(deny) deny.textContent = 'You must be ' + minAge + ' or older to enter this site.';
  });

  ['gate-m','gate-d','gate-y'].forEach(function(id){
    var el = document.getElementById(id);
    if(!el) return;
    el.addEventListener('input',  function(){ if(deny) deny.textContent = ''; });
    el.addEventListener('change', function(){ if(deny) deny.textContent = ''; });
    el.addEventListener('keydown', function(ev){ if(ev.key === 'Enter' && yes) yes.click(); });
  });

  /* ---------- bottle tilt (homepage only) ---------- */
  if(!reduce && hero && bottleWrap){
    hero.addEventListener('mousemove', function(ev){
      var r = hero.getBoundingClientRect();
      var dx = (ev.clientX-r.left)/r.width - .5, dy = (ev.clientY-r.top)/r.height - .5;
      bottleWrap.style.setProperty('--tilty',(dx*7).toFixed(2)+'deg');
      bottleWrap.style.setProperty('--tiltx',(dy*-5).toFixed(2)+'deg');
    });
    hero.addEventListener('mouseleave', function(){
      bottleWrap.style.setProperty('--tilty','0deg');
      bottleWrap.style.setProperty('--tiltx','0deg');
    });
  }
})();